<template>
  <div class="ads-carousel" :class="{ 'ads-carousel-round-effect': isSwiperReady }">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <swiper
      ref="mySwiper"
      :options="swiperOption"
      :auto-update="true"
      :auto-destroy="true"
      :delete-instance-on-destroy="true"
      :cleanup-styles-on-destroy="true"
      @ready="handleSwiperReadied">
      <swiper-slide
        v-for="(banner, index) in banners"
        :key="banner.index"
        :class="'swiper-slide' + (index + 1)">
        <div class="page">
          <a v-bind:href="banner.ta_url" target="_blank">
            <img :src="banner.ta_pic" />
          </a>
        </div>
      </swiper-slide>
    </swiper>
    <div @click="toList" class="all-banner">
      全部
      <span class="down">
        <img src="../../assets/img/arrow-down.svg" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'carrousel',
  props: {
    banners: {
      type: Array,
      ta_pic: '../../images/placholder_1200.svg',
      ta_url: ''
    }
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      swiperOption: {
        slidesPerView:'auto',
        loopedSlides : this.banners.length,
        initialSlide: 0,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
          bulletClass: 'item-inactive',
          bulletActiveClass: 'item-active',
        },
        followFinger: false,
        observer: true,
        observeParents: true,
      },
      isSwiperReady: false,
      isLoading: true,
    }
  },
  methods: {
    getData () {
        this.isLoading = false;
    },
    toList() {
      this.$router.push({ name: 'bannerList', params: { list: this.banners } })
    },
    handleSwiperReadied() {
      this.isSwiperReady = true
    },
  },
}
</script>

<style lang="scss" scoped>
.ads-carousel {
  position: relative;
  z-index: 0;
  padding: 0 4.8%;
  * {
    user-select: auto;
    -webkit-touch-callout: auto;
    touch-action: auto;
  }
  .swiper-container {
    border-radius: 16px;
    overflow: hidden;
    background-color: #fff;
    font-size: 0;
  }
}
.page {
  width: 100%;
  a {
    display: block;
    min-height: 150px;
    background: url('../../assets/img/placholder_1200.svg');
    background-size: contain;
    background-repeat: no-repeat;
  }
  img {
    width: 100%;
    min-height: 150px;
    &.error-img {
      display: none;
      & + .error-holder {
        display: block;
      }
    }
  }
  .error-holder {
    display: none;
  }
}
.all-banner {
  position: absolute;
  z-index: 1;
  right: 7.2%;
  bottom: 5%;
  font-size: 12px;
  color: #545454;
  width: 48px;
  height: 18px;
  background-color: rgba(249, 250, 251, 0.6);
  border-radius: 12px;
  text-align: center;
  padding-left: 8px;
  padding-right: 4px;

  .down {
    display: inline-block;
    width: 10px;
    height: 10px;
    font-size: 0;
    margin-left: -3px;
    padding-top: 2px;
    img {
      width: 100%;
    }
  }
}
</style>
